const i18nConfig = {
  locales: ['vi', 'en'],
  defaultLocale: 'vi',
  keySeparator: false,
}

module.exports = i18nConfig